document.addEventListener("DOMContentLoaded", function () {
  // ==================== ENGRAVING MODAL + SUMMARY + CART PROPERTIES ====================

  const buyButtonsContainer = document.querySelector("buy-buttons");

  const openModalBtn = document.getElementById("customization-modal");
  const closeModalBtn = document.getElementById("closeModalBtn");
  const modalOverlay = document.getElementById("modalOverlay");
  const saveOrderBtn = document.getElementById("saveOrderBtn");
  const clearCustomizationBtn = document.getElementById("clearCustomization");

  const modalInput1 = document.getElementById("modalInput1");
  const modalInput2 = document.getElementById("modalInput2");

  const previewImg = document.getElementById("engravingPlatePreviewImg");

  const atcSlot = document.getElementById("pdpRealAtcSlot");
  const summaryCard = document.getElementById("pdpAtcSummaryCard");
  const summaryDetails = document.getElementById("engravingSummaryDetails");
  const noneText = document.getElementById("engravingNoneText");
  const engravingAddedText = document.getElementById("engravingAddedText");
  const shippingEstimateText = document.getElementById("pdpShippingEstimateText");

  const plateImages = {
    "Brass|Rounded": {
      src: "https://cdn.shopify.com/s/files/1/0717/8498/8717/files/Brass_plate_rounded.jpg?v=1779323397",
      alt: "Brass engraved plate with rounded corners"
    },
    "Brass|Square": {
      src: "https://cdn.shopify.com/s/files/1/0717/8498/8717/files/Brass_plate_square.jpg?v=1779323397",
      alt: "Brass engraved plate with square corners"
    },
    "Nickel|Rounded": {
      src: "https://cdn.shopify.com/s/files/1/0717/8498/8717/files/Nickel_plate_rounded.jpg?v=1779323397",
      alt: "Nickel engraved plate with rounded corners"
    },
    "Nickel|Square": {
      src: "https://cdn.shopify.com/s/files/1/0717/8498/8717/files/Nickel_plate_square.jpg?v=1779323397",
      alt: "Nickel engraved plate with square corners"
    }
  };

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function getSelectedPlateType() {
    return document.querySelector('input[name="modal_plate_type"]:checked')?.value || "Brass";
  }

  function getSelectedCornerType() {
    return document.querySelector('input[name="modal_corner_type"]:checked')?.value || "Rounded";
  }

  function openEngravingModal() {
    if (!modalOverlay) return;

    modalOverlay.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  function closeEngravingModal() {
    if (modalOverlay) modalOverlay.classList.remove("active");

    document.body.style.overflow = "";
  }

  function updatePlatePreview() {
    if (!previewImg) return;

    const plateTypeVal = getSelectedPlateType();
    const cornerTypeVal = getSelectedCornerType();
    const imageKey = `${plateTypeVal}|${cornerTypeVal}`;
    const selectedImage = plateImages[imageKey];

    if (!selectedImage) return;

    previewImg.src = selectedImage.src;
    previewImg.alt = selectedImage.alt;
  }

  function removeOldEngravingProperties() {
    if (!buyButtonsContainer) return;

    buyButtonsContainer.querySelectorAll("[data-impact-custom]").forEach(el => el.remove());
  }

  function addHiddenCartProperty(name, value, index) {
    if (!buyButtonsContainer || !value) return;

    const targetFormId = buyButtonsContainer.getAttribute("form");

    const input = document.createElement("input");
    input.type = "hidden";
    input.name = `properties[${name}]`;
    input.value = value;
    input.setAttribute("data-impact-custom", index);

    if (targetFormId) input.setAttribute("form", targetFormId);

    buyButtonsContainer.appendChild(input);
  }

  function syncEngravingPropertiesToCartForm() {
    if (!buyButtonsContainer) return;

    removeOldEngravingProperties();

    const val1 = modalInput1?.value.trim() || "";
    const val2 = modalInput2?.value.trim() || "";

    if (!val1 && !val2) return;

    const plateTypeVal = getSelectedPlateType();
    const cornerTypeVal = getSelectedCornerType();
    const optionsCompiledString = `${plateTypeVal} Plate, ${cornerTypeVal} Corners`;

    addHiddenCartProperty("Engraving Line 1", val1, "1");
    addHiddenCartProperty("Engraving Line 2", val2, "2");
    addHiddenCartProperty("Plate Options", optionsCompiledString, "3");
  }

  function updateEngravingSummary() {
    if (!summaryDetails || !noneText || !clearCustomizationBtn || !openModalBtn) return;

    const engravingRow = openModalBtn.closest(".pdp-custom-option-row");

    const line1 = modalInput1?.value.trim() || "";
    const line2 = modalInput2?.value.trim() || "";
    const hasEngraving = line1 || line2;

    summaryDetails.innerHTML = "";
    summaryDetails.style.display = "none";

    if (hasEngraving) {
      if (engravingRow) engravingRow.classList.add("is-selected");

      noneText.style.display = "none";

      if (engravingAddedText) engravingAddedText.style.display = "inline";

      clearCustomizationBtn.style.display = "inline-flex";
      openModalBtn.textContent = "Edit";
    } else {
      if (engravingRow) engravingRow.classList.remove("is-selected");

      noneText.style.display = "inline";

      if (engravingAddedText) engravingAddedText.style.display = "none";

      clearCustomizationBtn.style.display = "none";
      openModalBtn.textContent = "Add Engraving";
    }
  }

  function showEngravingError(message) {
    let errorEl = document.getElementById("engravingModalError");

    if (!errorEl && saveOrderBtn) {
      errorEl = document.createElement("div");
      errorEl.id = "engravingModalError";
      errorEl.className = "engraving-modal-error";
      saveOrderBtn.insertAdjacentElement("beforebegin", errorEl);
    }

    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = "block";
    }
  }

  function hideEngravingError() {
    const errorEl = document.getElementById("engravingModalError");

    if (errorEl) {
      errorEl.textContent = "";
      errorEl.style.display = "none";
    }
  }

  function clearCustomizationData() {
    if (modalInput1) modalInput1.value = "";
    if (modalInput2) modalInput2.value = "";

    document.querySelectorAll('input[name="modal_plate_type"], input[name="modal_corner_type"]').forEach(radio => {
      radio.checked = radio.value === "Brass" || radio.value === "Rounded";
    });

    removeOldEngravingProperties();
    updateEngravingSummary();
    updatePlatePreview();
    hideEngravingError();
  }

  function resetEngravingUiOnly() {
    clearCustomizationData();
  }

  // ==================== INSERT MODAL ====================

  const insertTriggerBtn = document.getElementById("insert-modal-trigger");
  const insertModalOverlay = document.getElementById("insertModalOverlay");
  const closeInsertModalBtn = document.getElementById("closeInsertModalBtn");
  const saveInsertBtn = document.getElementById("saveInsertBtn");
  const clearInsertBtn = document.getElementById("clearInsertCustomization");

  const pdpInsertPreview = document.getElementById("pdpInsertPreview");
  const displayInsertPreview = document.getElementById("displayInsertPreview");
  const insertGrid = document.getElementById("insertGrid");

  const insertNoneText = document.getElementById("insertNoneText");
  const insertAddedText = document.getElementById("insertAddedText");
  const insertSummaryDetails = document.getElementById("insertSummaryDetails");

  let selectedInsert = {
    variantId: null,
    label: "No Insert (+$0.00)"
  };

  function formatInsertSummaryLabel(label) {
    return String(label || "")
      .replace(/\(\+\$0\.00\)/g, "")
      .replace(/\(\+\$([0-9,.]+)\)/g, "• $$$1")
      .replace(/\s+/g, " ")
      .trim();
  }

  async function fetchVariantPrice(variantId) {
    if (!variantId) return null;

    try {
      const res = await fetch(`/variants/${variantId}.js`);

      if (!res.ok) throw new Error();

      const data = await res.json();

      return data.price;
    } catch (e) {
      console.warn("Could not fetch price for variant", variantId);
      return null;
    }
  }

  function getInsertButtonText(optionVariantId) {
    const optionId = optionVariantId ? String(optionVariantId) : "";
    const selectedId = selectedInsert.variantId ? String(selectedInsert.variantId) : "";

    if (!selectedId) {
      return optionId ? "Add to order" : "No Insert";
    }

    if (!optionId) {
      return "No Insert";
    }

    if (optionId === selectedId) {
      return "Keep selection";
    }

    return "Update cart";
  }

  function syncInsertCardButtons() {
    document.querySelectorAll(".insert-option-card").forEach(card => {
      const button = card.querySelector(".btn-card-select");
      if (!button) return;

      const cardVariantId = card.dataset.variantId || "";
      const selectedId = selectedInsert.variantId ? String(selectedInsert.variantId) : "";

      button.textContent = getInsertButtonText(cardVariantId);
      button.disabled = false;
      button.classList.remove("is-loading", "is-secondary");

      const isNoInsertButton = !cardVariantId;
      const isCurrentPaidSelection = selectedId && cardVariantId === selectedId;

      if (isNoInsertButton && !selectedId) {
        button.classList.add("is-secondary");
      }

      if (isCurrentPaidSelection) {
        button.classList.add("is-secondary");
      }
    });
  }

  async function buildInsertCards() {
    if (!insertGrid || !window.insertOptions) return;

    insertGrid.innerHTML = "";

    for (let option of window.insertOptions) {
      let price = option.price;

      if (option.id) {
        const livePrice = await fetchVariantPrice(option.id);
        if (livePrice !== null) price = livePrice;
      }

      const formattedPrice = price === 0 ? "$0.00" : `$${(price / 100).toFixed(2)}`;
      const displayLabel = `${option.label} (+${formattedPrice})`;
      const buttonText = getInsertButtonText(option.id);

      const imageHtml = option.image
        ? `<img src="${escapeHtml(option.image)}" alt="${escapeHtml(option.label)}" class="insert-box-modal-image">`
        : `<span>${escapeHtml(option.label)} Preview</span>`;

      const descriptionHtml = option.description || "";

      const cardHTML = `
        <div class="insert-option-card" data-variant-id="${option.id || ""}" data-label="${escapeHtml(displayLabel)}">
          <div class="insert-card-img-placeholder">${imageHtml}</div>
          <h3 class="insert-card-title">${escapeHtml(option.label)}</h3>
          <p class="insert-card-price">${formattedPrice}</p>
          <p class="insert-card-desc">${descriptionHtml}</p>
          <button type="button" class="btn-card-select">${buttonText}</button>
        </div>
      `;

      insertGrid.insertAdjacentHTML("beforeend", cardHTML);
    }

    attachCardListeners();
    syncInsertCardButtons();
  }

  function updateInsertSummary() {
    if (!insertNoneText || !insertSummaryDetails || !insertTriggerBtn) return;

    const insertRow = insertTriggerBtn.closest(".pdp-custom-option-row");

    insertSummaryDetails.innerHTML = "";
    insertSummaryDetails.style.display = "none";

    if (selectedInsert.variantId) {
      if (insertRow) insertRow.classList.add("is-selected");

      insertNoneText.style.display = "none";

      if (insertAddedText) {
        insertAddedText.textContent = formatInsertSummaryLabel(selectedInsert.label);
        insertAddedText.style.display = "inline";
      }

      if (clearInsertBtn) clearInsertBtn.style.display = "inline-flex";

      insertTriggerBtn.textContent = "Edit";
    } else {
      if (insertRow) insertRow.classList.remove("is-selected");

      insertNoneText.style.display = "inline";

      if (insertAddedText) {
        insertAddedText.textContent = "";
        insertAddedText.style.display = "none";
      }

      if (clearInsertBtn) clearInsertBtn.style.display = "none";

      insertTriggerBtn.textContent = "View Inserts";
    }
  }

  async function addSelectedInsertToCart() {
    if (!selectedInsert.variantId) return false;

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: Number(selectedInsert.variantId),
          quantity: 1
        })
      });

      if (!res.ok) {
        const errorData = await res.json().catch(() => null);
        console.error("Insert cart add failed:", errorData);
        alert(errorData?.description || "Could not add insert. Please try again.");
        return false;
      }
    } catch (err) {
      console.error("Insert cart request failed:", err);
      alert("Could not add insert. Please try again.");
      return false;
    }

    if (displayInsertPreview) displayInsertPreview.textContent = selectedInsert.label;
    if (pdpInsertPreview) pdpInsertPreview.style.display = "block";

    updateInsertSummary();

    document.dispatchEvent(new CustomEvent("cart:refresh", {
      detail: {
        source: "insert-customization"
      }
    }));

    syncInsertCardButtons();

    return true;
  }

  async function removeInsertFromCart(variantIdOverride) {
    const variantIdToRemove = Number(variantIdOverride || selectedInsert.variantId);

    if (!Number.isInteger(variantIdToRemove) || variantIdToRemove <= 0) {
      console.warn("No valid insert variant ID to remove:", variantIdOverride || selectedInsert.variantId);
      return true;
    }

    try {
      const cartRes = await fetch("/cart.js", {
        headers: {
          "Accept": "application/json"
        }
      });

      if (!cartRes.ok) {
        throw new Error("Could not fetch cart");
      }

      const cart = await cartRes.json();

      const matchingItem = cart.items.find(item => {
        return Number(item.variant_id) === variantIdToRemove;
      });

      if (!matchingItem) {
        console.warn("Insert variant was not found in cart:", variantIdToRemove);
        return true;
      }

      const currentQuantity = Number(matchingItem.quantity || 1);
      const newQuantity = Math.max(0, currentQuantity - 1);

      const removeRes = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: matchingItem.key,
          quantity: newQuantity
        })
      });

      if (!removeRes.ok) {
        const errorData = await removeRes.json().catch(() => null);
        console.error("Insert cart remove failed:", errorData);
        alert(errorData?.description || "Could not remove insert from cart. Please try again.");
        return false;
      }

      document.dispatchEvent(new CustomEvent("cart:refresh", {
        detail: {
          source: "insert-customization"
        }
      }));

      return true;
    } catch (err) {
      console.error("Insert cart remove request failed:", err);
      alert("Could not remove insert from cart. Please try again.");
      return false;
    }
  }

  async function clearInsertData() {
    const removed = await removeInsertFromCart(selectedInsert.variantId);

    if (!removed) return false;

    selectedInsert = {
      variantId: null,
      label: "No Insert (+$0.00)"
    };

    if (pdpInsertPreview) pdpInsertPreview.style.display = "none";
    if (displayInsertPreview) displayInsertPreview.textContent = "";

    updateInsertSummary();
    syncInsertCardButtons();

    return true;
  }

  function resetInsertUiOnly() {
    selectedInsert = {
      variantId: null,
      label: "No Insert (+$0.00)"
    };

    if (pdpInsertPreview) pdpInsertPreview.style.display = "none";
    if (displayInsertPreview) displayInsertPreview.textContent = "";

    updateInsertSummary();
    syncInsertCardButtons();
  }

  function attachCardListeners() {
    document.querySelectorAll(".insert-option-card .btn-card-select").forEach(button => {
      button.addEventListener("click", async event => {
        event.preventDefault();

        const card = button.closest(".insert-option-card");
        if (!card) return;

        const newVariantId = card.dataset.variantId || null;
        const newLabel = card.dataset.label || "No Insert (+$0.00)";
        const currentVariantId = selectedInsert.variantId ? String(selectedInsert.variantId) : "";
        const clickedVariantId = newVariantId ? String(newVariantId) : "";

        if (!clickedVariantId) {
          button.textContent = "Removing...";
          button.disabled = true;
          button.classList.add("is-loading");

          const cleared = await clearInsertData();

          button.disabled = false;
          button.classList.remove("is-loading");

          if (cleared) closeInsertModal();

          return;
        }

        if (currentVariantId && clickedVariantId === currentVariantId) {
          closeInsertModal();
          return;
        }

        const originalButtonText = button.textContent;
        button.textContent = currentVariantId ? "Updating..." : "Adding...";
        button.disabled = true;
        button.classList.add("is-loading");

        if (currentVariantId) {
          const removed = await removeInsertFromCart(currentVariantId);

          if (!removed) {
            button.textContent = originalButtonText;
            button.disabled = false;
            button.classList.remove("is-loading");
            return;
          }
        }

        selectedInsert = {
          variantId: newVariantId,
          label: newLabel
        };

        const added = await addSelectedInsertToCart();

        button.disabled = false;
        button.classList.remove("is-loading");

        if (added) {
          syncInsertCardButtons();
          closeInsertModal();
        } else {
          button.textContent = originalButtonText;
        }
      });
    });
  }

  function openInsertModal() {
    if (!insertModalOverlay) return;

    insertModalOverlay.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  function closeInsertModal() {
    if (insertModalOverlay) insertModalOverlay.classList.remove("active");

    document.body.style.overflow = "";
  }

  // ==================== EVENT LISTENERS ====================

  if (openModalBtn) {
    openModalBtn.addEventListener("click", openEngravingModal);
  }

  if (closeModalBtn) {
    closeModalBtn.addEventListener("click", closeEngravingModal);
  }

  if (saveOrderBtn) {
    saveOrderBtn.addEventListener("click", event => {
      event.preventDefault();

      const val1 = modalInput1?.value.trim() || "";
      const val2 = modalInput2?.value.trim() || "";

      if (!val1 && !val2) {
        showEngravingError("Fill out at least one text field above to add plate.");
        return;
      }

      hideEngravingError();
      syncEngravingPropertiesToCartForm();
      updateEngravingSummary();
      closeEngravingModal();
    });
  }

  if (clearCustomizationBtn) {
    clearCustomizationBtn.addEventListener("click", clearCustomizationData);
  }

  [modalInput1, modalInput2].forEach(input => {
    if (!input) return;

    input.addEventListener("input", () => {
      const val1 = modalInput1?.value.trim() || "";
      const val2 = modalInput2?.value.trim() || "";

      if (val1 || val2) {
        hideEngravingError();
      }
    });
  });

  if (modalOverlay) {
    modalOverlay.addEventListener("click", event => {
      if (event.target === modalOverlay) closeEngravingModal();
    });
  }

  if (insertTriggerBtn) {
    insertTriggerBtn.addEventListener("click", async () => {
      if (insertGrid && insertGrid.children.length === 0) {
        await buildInsertCards();
      }

      syncInsertCardButtons();
      openInsertModal();
    });
  }

  if (closeInsertModalBtn) {
    closeInsertModalBtn.addEventListener("click", closeInsertModal);
  }

  if (insertModalOverlay) {
    insertModalOverlay.addEventListener("click", event => {
      if (event.target === insertModalOverlay) closeInsertModal();
    });
  }

  if (saveInsertBtn) {
    saveInsertBtn.style.display = "none";
  }

  if (clearInsertBtn) {
    clearInsertBtn.addEventListener("click", async () => {
      await clearInsertData();
    });
  }

  document.addEventListener("keydown", event => {
    if (event.key !== "Escape") return;

    if (modalOverlay?.classList.contains("active")) closeEngravingModal();
    if (insertModalOverlay?.classList.contains("active")) closeInsertModal();
  });

  document.querySelectorAll('input[name="modal_plate_type"], input[name="modal_corner_type"]').forEach(radio => {
    radio.addEventListener("change", updatePlatePreview);
  });

  function bindMainProductAddToCartReset() {
    let resetTimer = null;

    function schedulePdpCustomizationReset() {
      window.clearTimeout(resetTimer);

      resetTimer = window.setTimeout(() => {
        resetEngravingUiOnly();
        resetInsertUiOnly();
      }, 1500);
    }

    function isInsideCustomizationModal(element) {
      return Boolean(
        element.closest("#insertModalOverlay") ||
        element.closest("#modalOverlay")
      );
    }

    function isMainProductAddButton(element) {
      const button = element.closest(
        'button[name="add"], button[type="submit"], .product-form__submit'
      );

      if (!button) return false;
      if (isInsideCustomizationModal(button)) return false;

      const form =
        button.closest('form[action*="/cart/add"]') ||
        document.getElementById(button.getAttribute("form"));

      if (!form) return false;

      return true;
    }

    document.addEventListener("click", event => {
      if (!isMainProductAddButton(event.target)) return;

      schedulePdpCustomizationReset();
    }, true);

    document.addEventListener("submit", event => {
      const form = event.target;

      if (!form.matches('form[action*="/cart/add"]')) return;
      if (isInsideCustomizationModal(form)) return;

      schedulePdpCustomizationReset();
    }, true);

    document.addEventListener("cart:refresh", event => {
      if (event.detail?.source === "insert-customization") return;

      schedulePdpCustomizationReset();
    });
  }

  // ==================== INIT ====================

  updatePlatePreview();
  updateEngravingSummary();
  updateInsertSummary();
  bindMainProductAddToCartReset();

  // Move ATC button, kept minimal.
  function moveRealAtcButtonIntoSummaryCard() {
    if (!atcSlot || !summaryCard) return;
  }

  moveRealAtcButtonIntoSummaryCard();
});
/* ==========================================================================
   SERVICE DATE + FREE RUSH UPGRADE

   Markup: snippets/hm-service-date.liquid
   Dates:  assets/hmm-delivery.js (window.HMDelivery)

   Kept in its own closure so it shares nothing with the engraving/insert code
   above. Talks to the rest of the page only through the hmm:delivery-changed
   event, which the PDP reassurance tile listens for.
   ========================================================================== */

document.addEventListener("DOMContentLoaded", function () {
  var HMD = window.HMDelivery;

  var row = document.querySelector("[data-hm-service-date-row]");
  var modal = document.querySelector("[data-hm-service-modal]");

  if (!HMD || !row || !modal) return;

  var prompt = row.querySelector("[data-hm-service-prompt]");
  var summary = row.querySelector("[data-hm-service-summary]");
  var addedText = row.querySelector("[data-hm-service-added]");
  var details = row.querySelector("[data-hm-service-details]");
  var openBtn = row.querySelector("[data-hm-service-open]");
  var clearBtn = row.querySelector("[data-hm-service-clear]");

  var dateInput = modal.querySelector("[data-hm-service-input]");
  var zipInput = modal.querySelector("[data-hm-service-zip]");
  var result = modal.querySelector("[data-hm-service-result]");
  var saveBtn = modal.querySelector("[data-hm-service-save]");

  var PHONE = '<a href="tel:8339330054">833-933-0054</a>';

  /* Free-shipping discount, capped at $150 per shipment with a 25-redemption
     limit. Checkout lists the paid express rates next to the free one, so a
     shopper we just promised a free upgrade would otherwise be looking at
     "UPS 2nd Day Air $61.43" and reasonably conclude that is how to get it.
     Applying this makes the express rate actually free.

     Hiding or renaming rates conditionally would need a Delivery Customization
     function, which is Plus-only. See docs/rush-shipping-plan.md.

     Belt and braces: if they pick the free base rate anyway, the RUSH cart
     attribute still tells the fulfillment desk to upgrade the label. */
  var RUSH_DISCOUNT_CODE = "HMMRUSH7K42";

  var discountApplied = false;

  function applyRushDiscount() {
    if (discountApplied) return;
    discountApplied = true;

    /* Sets the discount on the session. Redirecting to /cart.js keeps it cheap
       — we only want the Set-Cookie, not a page. */
    fetch("/discount/" + RUSH_DISCOUNT_CODE + "?redirect=/cart.js", {
      credentials: "same-origin"
    }).catch(function () {
      /* If this fails they simply see the normal price and the desk still
         upgrades the label. Never block the sale on it. */
      discountApplied = false;
    });
  }

  /* Both rush states get the discount. Even when we could not confirm which
     service lands in time, we promised the upgrade would be free, so an express
     rate they pick must not charge them. Deliberately NOT applied to call_us —
     there we have said we cannot make the date, so express is a speed purchase
     they are choosing, not an upgrade we promised. */
  function overCap(plan) {
    return plan.status === "rush_confirmed" &&
      typeof plan.cost === "number" && plan.cost > RUSH_DISCOUNT_MAX;
  }

  function syncRushDiscount(plan) {
    /* A free-shipping discount does not part-pay: a rate above the cap gets
       nothing at all, so applying the code there would be theatre and would
       leave them looking at the full price on a rate we called free. */
    if (overCap(plan)) return;

    if (plan.status === "rush_confirmed" || plan.status === "rush_unconfirmed") {
      applyRushDiscount();
    }
  }

  /* rates: undefined until we look, null when the lookup failed, [] when the
     cart was empty so UPS had nothing to quote, otherwise live quotes. */
  var state = { serviceDate: "", zip: "", rates: undefined, loading: false };

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  /* The shopper has an engraved plate in the order. It is engraved to order and
     ships 1-2 weeks behind the urn, so it will not make a near-term service.
     Say so before they pay, not after. */
  function hasEngraving() {
    var engravingRow = document.querySelector(".pdp-engraving-summary-row");
    return Boolean(engravingRow && engravingRow.classList.contains("is-selected"));
  }

  function currentPlan() {
    return HMD.plan({ zip: state.zip, serviceDate: state.serviceDate, rates: state.rates });
  }

  /* Live UPS quotes for this ZIP. Only worth asking once ground has already
     missed the date — that is the only branch where the answer changes what we
     say, and the call costs about a second of somebody's UPS quota. */
  function ensureRates() {
    if (state.loading) return Promise.resolve(state.rates);

    var plan = HMD.plan({ zip: state.zip, serviceDate: state.serviceDate, rates: state.rates });
    if (plan.status !== "rush_unconfirmed") return Promise.resolve(state.rates);

    var zip = state.zip;
    state.loading = true;
    renderResult();

    return HMD.fetchRates(zip).then(function (rates) {
      state.loading = false;

      /* The shopper may have typed on while we were waiting. */
      if (zip !== state.zip) return state.rates;

      state.rates = rates;
      return rates;
    });
  }

  /* ---------------------------------------------------------------- copy --- */

  /* Cap on the free-shipping discount, in dollars. Above this the discount will
     not cover the rate, so the button must not name a figure it cannot honour.
     Must match maximumShippingPrice on the discount — see docs. The code itself
     is never rendered; it is applied via redirect only. */
  var RUSH_DISCOUNT_MAX = 150;

  function money(amount) {
    return "$" + Number(amount).toFixed(2);
  }

  function pill(kind, label) {
    return '<span class="hm-pill hm-pill--' + kind + '">' + label + "</span>";
  }

  /* One row per service: name, price, arrival, verdict. Built from whatever
     fetchRates() actually returned — never a hardcoded pair, and never an
     assumption that 2nd Day Air exists. 90210 currently quotes only the free
     rate plus 2nd Day Air; other ZIPs quote no air at all, or quote services
     carrying no delivery date. */
  function rateRow(name, priceHtml, dateHtml, verdict) {
    return '<li class="hm-rate">' +
      '<div class="hm-rate__line">' +
        '<span class="hm-rate__name">' + escapeHtml(name) + "</span>" +
        '<span class="hm-rate__price">' + priceHtml + "</span>" +
      "</div>" +
      '<div class="hm-rate__line hm-rate__line--meta">' +
        '<span class="hm-rate__date">' + dateHtml + "</span>" +
        verdict +
      "</div>" +
    "</li>";
  }

  function verdictFor(arrival, deadlineISO) {
    if (!arrival) return pill("pending", "Date confirmed later");
    return HMD.toISO(arrival) <= deadlineISO
      ? pill("ok", "Arrives in time")
      : pill("miss", "Misses the service");
  }

  /* The free row always shows OUR ground estimate, not any date the carrier may
     attach to the $0 rate. The ground/rush decision is made from that same
     number, so pill and outcome can never disagree. */
  function freeRow(plan, deadlineISO) {
    /* Always labelled the same way, whether or not we happened to fetch quotes.
       The carrier's own name for the $0 rate has been "UPS Ground" and is now
       "UPS Select", neither of which means anything to a shopper — and the row
       they may need to find at checkout is the paid one, which keeps its real
       quoted name. */
    return rateRow(
      HMD.GROUND_LABEL,
      "Free",
      plan.groundArrival ? escapeHtml(HMD.formatDate(plan.groundArrival)) : "&mdash;",
      verdictFor(plan.groundArrival, deadlineISO)
    );
  }

  function offerLine(plan) {
    var lead = "As our small way of saying thanks for choosing Howard Miller Memorial, " +
      "we will upgrade you to expedited shipping free of charge";

    /* Only claim "today" when today really is the ship day. */
    var tail = plan.estimate.shipsToday
      ? " if you order today."
      : ". This order ships " + escapeHtml(HMD.formatDate(plan.estimate.processing)) + ".";

    return '<p class="hm-service-offer">' + lead + tail + "</p>";
  }

  function resultHtml(plan) {
    var arrival = HMD.formatDate(plan.arrival, "long");

    if (plan.status === "no_zip") {
      return '<p class="hm-service-date-result__neutral">Add a ZIP code and we will tell you exactly when it lands.</p>';
    }

    if (plan.status === "off_network") {
      return '<p class="hm-service-date-result__warn">We ship free within the lower 48 only. For this address, please call us at ' +
        PHONE + " and we will work it out with you.</p>";
    }

    if (plan.status === "no_date") {
      return '<p class="hm-service-date-result__neutral">Free shipping arrives <strong>' +
        escapeHtml(arrival) + "</strong>. Add a service date and we will check that against it.</p>";
    }

    var deadlineISO = HMD.toISO(HMD.addDays(plan.serviceDate, HMD.BUFFER_DAYS * -1));
    var rows = "";
    var trailer = "";

    if (plan.status === "ground_ok") {
      rows = freeRow(plan, deadlineISO);
      trailer = '<p class="hm-service-offer hm-service-offer--calm">Good news! Order today and it will arrive in time with free standard shipping.</p>';

    } else if (state.loading) {
      rows = freeRow(plan, deadlineISO);
      trailer = '<p class="hm-service-offer hm-service-offer--calm">Checking faster options for this ZIP&hellip;</p>';

    } else if (plan.status === "rush_unconfirmed") {
      /* No usable quotes — usually an empty cart. Show the free service missing
         the date and one honest line. No price, no invented row. */
      rows = freeRow(plan, deadlineISO);

      trailer = plan.unconfirmedReason === "no_dates"
        ? '<p class="hm-service-offer">We will upgrade you to the fastest available service <strong>free of charge</strong>. ' +
          "We could not confirm an exact arrival date for this ZIP automatically — call us at " + PHONE +
          " if you need certainty before ordering.</p>"
        : '<p class="hm-service-offer">We will upgrade you to the fastest available service <strong>free of charge</strong>. ' +
          "Add to cart and we will confirm the exact date.</p>";

    } else if (plan.status === "call_us") {
      rows = freeRow(plan, deadlineISO);

      (state.rates || []).filter(function (r) { return !r.isBaseline; })
        .sort(function (a, b) { return a.price - b.price; })
        .forEach(function (rate) {
          rows += rateRow(
            rate.name,
            money(rate.price),
            rate.arrival ? escapeHtml(HMD.formatDate(rate.arrival)) : "Date not quoted",
            verdictFor(rate.arrival, deadlineISO)
          );
        });

      var serviceDay = escapeHtml(HMD.formatDate(plan.serviceDate, "long"));
      var reason;

      if (plan.impossible) {
        /* The earliest arrival can be the service day itself, and naming both
           dates printed the same date twice and read as a contradiction. */
        var earliestDay = escapeHtml(HMD.formatDate(plan.earliest, "long"));

        reason = HMD.toISO(plan.earliest) === HMD.toISO(plan.serviceDate)
          ? "The soonest anything can reach you is <strong>" + earliestDay +
            "</strong> \u2014 the day of the service itself, so we cannot promise it arrives before it begins."
          : "The soonest anything can reach you is <strong>" + earliestDay +
            "</strong>, which is after the service on <strong>" + serviceDay + "</strong>.";
      } else if (plan.fastest && HMD.toISO(plan.arrival) === HMD.toISO(plan.serviceDate)) {
        /* Same day as the service. Saying "after the service on <same date>"
           printed one date twice and read as a contradiction. */
        reason = "The fastest option we can quote arrives <strong>" +
          escapeHtml(HMD.formatDate(plan.arrival, "long")) +
          "</strong>, the same day as the service, so we cannot promise it lands before it begins.";
      } else if (plan.fastest) {
        reason = "The fastest option we can quote arrives <strong>" +
          escapeHtml(HMD.formatDate(plan.arrival, "long")) + "</strong>, after the service on <strong>" +
          serviceDay + "</strong>.";
      } else {
        reason = "We could not find a service fast enough for this ZIP to arrive before the service on <strong>" +
          serviceDay + "</strong>.";
      }

      trailer = '<p class="hm-service-offer hm-service-offer--warn">' + reason +
        " Please call us at " + PHONE + " — there may still be something we can do.</p>";

    } else {
      /* rush_confirmed */
      rows = freeRow(plan, deadlineISO);

      (state.rates || []).filter(function (r) { return !r.isBaseline; })
        .sort(function (a, b) { return a.price - b.price; })
        .forEach(function (rate) {
          rows += rateRow(
            rate.name,
            money(rate.price),
            rate.arrival ? escapeHtml(HMD.formatDate(rate.arrival)) : "Date not quoted",
            verdictFor(rate.arrival, deadlineISO)
          );
        });

      trailer = overCap(plan)
        ? '<p class="hm-service-offer">' +
          "As our small way of saying thanks for choosing Howard Miller Memorial, we will upgrade " +
          "you to <strong>" + escapeHtml(plan.serviceLabel) + "</strong> free of charge. " +
          "<strong>Choose standard shipping at checkout</strong> — we pay for the upgrade at our end, " +
          "so there is nothing for you to select." +
          (plan.estimate.shipsToday ? " Order today and it ships today." :
            " This order ships " + escapeHtml(HMD.formatDate(plan.estimate.processing)) + ".") +
          "</p>"
        : offerLine(plan);
    }

    var html = '<ul class="hm-rate-list">' + rows + "</ul>" + trailer;

    if (hasEngraving() && (plan.status === "rush_confirmed" || plan.status === "rush_unconfirmed")) {
      html += '<p class="hm-service-date-result__warn">Your engraved plate is made to order and ships separately, ' +
        "1-2 weeks behind the urn. It will not arrive before the service.</p>";
    }

    return html;
  }

  /* Names the amount only when the discount will actually cover it. */
  function saveLabel(plan) {
    if (plan.status === "rush_confirmed") {
      return typeof plan.cost === "number" && plan.cost > 0 && plan.cost <= RUSH_DISCOUNT_MAX
        ? "Apply " + money(plan.cost) + " shipping discount"
        : "Apply free shipping upgrade";
    }

    if (plan.status === "rush_unconfirmed") return "Apply free shipping upgrade";

    return "Save date";
  }

  function summaryText(plan) {
    var date = HMD.parseISO(state.serviceDate);
    if (!date) return "";

    var label = HMD.formatDate(date);

    if (plan.status === "ground_ok") return label + " · arrives " + HMD.formatDate(plan.arrival);
    if (plan.status === "rush_confirmed") return label + " · free rush upgrade";
    if (plan.status === "rush_unconfirmed") return label + " · checking fastest option";
    if (plan.status === "call_us") return label + " · please call us";
    if (plan.status === "off_network") return label + " · call for options";

    return label;
  }

  function detailText(plan) {
    if (plan.status === "rush_confirmed") {
      return plan.serviceLabel + ", free — arrives " + HMD.formatDate(plan.arrival, "long");
    }

    if (plan.status === "rush_unconfirmed") {
      return "Fastest available service, free — confirming arrival date";
    }

    if (plan.status === "ground_ok") {
      return "Free shipping";
    }

    return "";
  }

  /* ---------------------------------------------------------------- view --- */

  function renderRow() {
    var hasDate = Boolean(HMD.parseISO(state.serviceDate));
    var plan = currentPlan();

    row.classList.toggle("is-selected", hasDate);
    if (prompt) prompt.hidden = hasDate;
    if (summary) summary.hidden = !hasDate;
    if (clearBtn) clearBtn.hidden = !hasDate;
    if (openBtn) openBtn.textContent = hasDate ? "Change" : "Delivery Estimate";

    if (addedText) addedText.textContent = hasDate ? summaryText(plan) : "";

    if (details) {
      var detail = hasDate ? detailText(plan) : "";
      details.hidden = !detail;
      details.textContent = detail;
    }

    row.classList.toggle(
      "is-rush",
      plan.status === "rush_confirmed" || plan.status === "rush_unconfirmed"
    );
  }

  function renderResult() {
    var plan = currentPlan();
    if (result) result.innerHTML = resultHtml(plan);
    if (saveBtn) saveBtn.textContent = state.loading ? "Save date" : saveLabel(plan);
  }

  function announce() {
    document.dispatchEvent(new CustomEvent("hmm:delivery-changed", {
      detail: { serviceDate: state.serviceDate, zip: state.zip, plan: currentPlan() }
    }));
  }

  /* ---------------------------------------------------------------- cart --- */

  function writeAttributes() {
    var plan = currentPlan();
    var hasDate = Boolean(HMD.parseISO(state.serviceDate));

    var shipMethod = "";

    if (hasDate) {
      if (plan.status === "rush_confirmed") {
        shipMethod = "RUSH - " + plan.serviceLabel + " (free upgrade)";
      } else if (plan.status === "rush_unconfirmed") {
        /* We know ground misses but nothing has quoted this ZIP. The desk buys
           the fastest service that lands before the date. */
        shipMethod = "RUSH - buy fastest service arriving before the service date";
      } else if (plan.status === "ground_ok") {
        shipMethod = "Free ground - no upgrade needed";
      } else if (plan.status === "call_us") {
        shipMethod = "NEEDS A CALL - no service arrives before the date";
      }
    }

    var attributes = {
      "Service Date": hasDate ? state.serviceDate : "",
      "Service ZIP": state.zip || "",
      "Ship Method": shipMethod,
      "Ground ETA": hasDate && plan.groundArrival ? HMD.toISO(plan.groundArrival) : ""
    };

    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {
      /* A failed write must not block the sale. The date still shows on the
         page and the shopper can add it to the order notes at checkout. */
    });
  }

  function readAttributes() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.attributes) return;

        var stored = cart.attributes["Service Date"];
        if (stored && HMD.parseISO(stored)) state.serviceDate = stored;

        var storedZip = String(cart.attributes["Service ZIP"] || "").replace(/\D/g, "");
        if (storedZip.length === 5) state.zip = storedZip;
      })
      .catch(function () { /* fall back to whatever localStorage had */ });
  }

  /* ---------------------------------------------------------------- modal -- */

  function openModal() {
    if (dateInput) {
      var now = HMD.nowEastern();
      dateInput.min = HMD.toISO(now.date);
      dateInput.value = state.serviceDate || "";
    }

    if (zipInput) zipInput.value = state.zip || "";

    renderResult();
    modal.classList.add("active");

    window.setTimeout(function () {
      if (dateInput) dateInput.focus();
    }, 50);
  }

  function closeModal() {
    modal.classList.remove("active");
    if (openBtn) openBtn.focus();
  }

  function readInputs() {
    state.serviceDate = dateInput ? dateInput.value : "";
    state.zip = String(zipInput ? zipInput.value : "").replace(/\D/g, "").slice(0, 5);
  }

  function save() {
    readInputs();
    HMD.writeZip(state.zip);

    /* Resolve the upgrade before writing, so the order carries the service UPS
       actually quoted rather than a placeholder, whenever the cart lets us ask. */
    ensureRates().then(function () {
      renderRow();
      renderResult();
      writeAttributes();
      syncRushDiscount(currentPlan());
      announce();
      closeModal();
    });
  }

  function clear() {
    state.serviceDate = "";
    if (dateInput) dateInput.value = "";
    renderRow();
    writeAttributes();
    announce();
  }

  /* ---------------------------------------------------------------- bind --- */

  if (openBtn) openBtn.addEventListener("click", openModal);
  if (clearBtn) clearBtn.addEventListener("click", clear);
  if (saveBtn) saveBtn.addEventListener("click", save);

  modal.querySelectorAll("[data-hm-service-close]").forEach(function (button) {
    button.addEventListener("click", closeModal);
  });

  modal.addEventListener("click", function (event) {
    if (event.target === modal) closeModal();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && modal.classList.contains("active")) closeModal();
  });

  var lookupTimer = null;

  [dateInput, zipInput].forEach(function (input) {
    if (!input) return;

    input.addEventListener("input", function () {
      var previousZip = state.zip;
      readInputs();

      /* A different destination invalidates whatever UPS told us. */
      if (state.zip !== previousZip) state.rates = undefined;

      renderResult();

      /* Settle before asking UPS — somebody typing a ZIP should cost one
         lookup, not five. */
      window.clearTimeout(lookupTimer);
      lookupTimer = window.setTimeout(function () {
        ensureRates().then(renderResult);
      }, 400);
    });
  });

  /* Adding to cart is what gives UPS something to quote, so an unconfirmed rush
     can usually be resolved right after. Re-ask, then rewrite the order
     attributes with the service UPS actually named. */
  document.addEventListener("cart:refresh", function () {
    state.rates = undefined;

    ensureRates().then(function () {
      renderRow();
      renderResult();

      var plan = currentPlan();
      if (plan.status === "rush_confirmed" || plan.status === "call_us") writeAttributes();
      syncRushDiscount(plan);

      announce();
    });
  });

  /* Adding or removing engraving changes the caveat we show. */
  document.addEventListener("click", function (event) {
    if (!event.target.closest(".pdp-engraving-summary-row, #saveOrderBtn, #clearCustomization")) return;
    window.setTimeout(renderResult, 0);
  });

  /* ---------------------------------------------------------------- init --- */

  state.zip = HMD.readZip();

  readAttributes().then(function () {
    renderRow();
    renderResult();

    /* If a rush is already pending on this cart, confirm it now that there are
       items to quote — this is what upgrades "RUSH - buy fastest" on the order
       into the actual service name. */
    return ensureRates();
  }).then(function () {
    renderRow();
    renderResult();

    var plan = currentPlan();
    if (plan.status === "rush_confirmed" || plan.status === "call_us") writeAttributes();
    syncRushDiscount(plan);

    announce();
  });
});
